import React from "react";
import { Box, Typography } from "@mui/joy";

const ImageHero = ({ project }) => {
  return (
    <Box
      sx={{
        position: "relative",
        height: "250px",
        borderRadius: "24px 24px 0 0",
        overflow: "hidden",
      }}
    >
      <img
        src={project.image}
        alt={project.title}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          paddingLeft: 2,
          paddingRight: 2,
          paddingTop: 4,
          background:
            "linear-gradient(to top, rgba(251,252,254,1) 0%, rgba(251,252,254,0.9) 50%, rgba(251,252,254,0.85) 65%, rgba(251,252,254,0.5) 80%, rgba(251,252,254,0.2) 90%, rgba(251,252,254,0) 100%)",
          zIndex: 1,
        }}
      >
        <Typography
          level="h2"
          sx={{
            textAlign: "left",
            width: "90%",
          }}
        >
          {project.title}
        </Typography>
      </Box>
    </Box>
  );
};

export default ImageHero;
